import { CardContent, Typography } from '@mui/material';

import { ChipGroupField } from '@occc-app/design-system';

import { PaymentInstrumentOption } from './types';

type PaymentInstrumentConstraintProps = {
  options: PaymentInstrumentOption[];
};

export const PaymentInstrumentConstraint = ({ options }: PaymentInstrumentConstraintProps) => (
  <CardContent sx={{ pt: 0 }}>
    <Typography variant='subtitle1' component='h4' paragraph>
      Payment Tender Constraint (optional)
    </Typography>
    <ChipGroupField name='paymentMethodConstraint.paymentInstruments' options={options} />
  </CardContent>
);
